import { supabase } from '@/lib/supabase'

export type InvoiceHistoryRow = {
  id: string
  created_at: string | null
  period_end: string | null
  amount_paid_cents: number | null
  currency: string | null
  status: string | null
  plan_name: string | null
  interval: 'month'|'year'|null
}

export async function listAccountInvoices(accountId: string, page = 1, pageSize = 10): Promise<{ rows: InvoiceHistoryRow[]; total: number }>{
  const from = Math.max(0, (page - 1) * pageSize)
  const to = from + pageSize - 1
  const { data: inv, error, count } = await supabase
    .from('billing_invoices')
    .select('id, created_at, period_end, amount_paid_cents, currency, status, subscription_id', { count: 'exact' })
    .eq('account_id', accountId)
    .order('created_at', { ascending: false })
    .range(from, to)
  if (error) throw error
  const invoices = (inv || []) as any[]
  if (!invoices.length) return { rows: [], total: Number(count || 0) }

  // Map subscription -> plan
  const subIds = Array.from(new Set(invoices.map(i => i.subscription_id).filter(Boolean))) as string[]
  const planMap = new Map<string, { name: string|null; interval: 'month'|'year'|null }>()
  if (subIds.length) {
    const { data: subs } = await supabase.from('subscriptions').select('stripe_subscription_id, plan_id').in('stripe_subscription_id', subIds)
    const planIds = Array.from(new Set(((subs||[]) as any[]).map(s => s.plan_id).filter(Boolean))) as string[]
    const { data: plans } = planIds.length ? await supabase.from('plans').select('id, name, features').in('id', planIds) : { data: [] as any[] }
    const planById = new Map<string, any>(((plans||[]) as any[]).map(p => [p.id, p]))
    for (const s of (subs || []) as any[]) {
      const p = s?.plan_id ? planById.get(s.plan_id) : null
      const fx: any = (p?.features || {})
      if (s?.stripe_subscription_id) planMap.set(String(s.stripe_subscription_id), { name: p?.name || null, interval: (fx?.interval === 'year' ? 'year' : 'month') })
    }
  }

  const rows: InvoiceHistoryRow[] = invoices.map((i:any) => ({
    id: i.id,
    created_at: i.created_at || null,
    period_end: i.period_end || null,
    amount_paid_cents: (typeof i.amount_paid_cents === 'number' ? i.amount_paid_cents : null),
    currency: (i.currency || null),
    status: i.status || null,
    plan_name: planMap.get(String(i.subscription_id || ''))?.name || null,
    interval: planMap.get(String(i.subscription_id || ''))?.interval || null,
  }))

  return { rows, total: Number(count || rows.length) }
}

